'use client';

import {
  accountsUrl,
  apiRoutes,
  publicHttpClient,
  type DefaultQueryError,
} from '@ahm/api-wrappers-core';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';

export type RegisterRequestBody = {
  name: string;
  mobile: string;
  email: string;
  country_code: string;
  time?: number;
  checksum?: string;
  saas_user?: boolean;
  categories?: UserCategory[];
  type?: string;
  firebase_sms_auth?: 'true';
  ahamove_sms_auth?: 'true';
  lat?: number;
  lng?: number;
  user_type?: string;
  referral_code?: string;
  facebook_id?: string;
  imei?: string;
  google_id?: string;
  appsflyer_id?: string;
  conversion_data?: Record<string, string | number | null | Date | undefined>;
  source?: string; // source | utm_source
  campaign?: string; // aff_sid
  click_id?: string; // aff_clickid
} & Record<string, string>;

export interface UserCategory {
  child_code: string[];
  code: string;
}

export interface RegisterResponse {
  _id: string;
  id: string;
  login_method: 'passcode' | 'otp';
  authenticate_type: string;
}

export const registerFn = async (body: RegisterRequestBody) => {
  const response = await publicHttpClient.post<RegisterResponse>(
    accountsUrl + apiRoutes.accounts.register,
    body,
    {
      withCredentials: true,
    }
  );
  return response.data;
};

export const useRegisterMutation = (
  opts?: UseMutationOptions<
    RegisterResponse,
    DefaultQueryError,
    RegisterRequestBody
  >
) =>
  useMutation<RegisterResponse, DefaultQueryError, RegisterRequestBody>({
    mutationFn: registerFn,
    ...opts,
  });
